"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL = void 0;
exports.SOCIAL = {
    telegram: {
        path: 'https://t.me/sk_rgs_online',
    },
    vk: {
        path: 'https://vk.com/rgs.online',
    },
};
